import { render, staticRenderFns } from "./OceanoTwoColumnSection.vue?vue&type=template&id=2f351f24&scoped=true"
import script from "./OceanoTwoColumnSection.vue?vue&type=script&lang=ts"
export * from "./OceanoTwoColumnSection.vue?vue&type=script&lang=ts"
import style0 from "./OceanoTwoColumnSection.vue?vue&type=style&index=0&id=2f351f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f351f24",
  null
  
)

export default component.exports